(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  let swiperInstance = null;

  function initOrDestroySwiper() {
    const screenWidth = window.innerWidth;
    const swiperContainer = document.querySelector(".features-swiper");
    if (!swiperContainer) return;

    if (screenWidth < 768 && !swiperInstance) {
      const wrapper = swiperContainer.closest(".features_section");
      if (wrapper) wrapper.style.display = "block";

      setTimeout(() => {
        swiperInstance = new Swiper(".features-swiper", {
          slidesPerView: 1,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          grabCursor: true,
          speed: 600,
        });
      }, 100);
    } else if (screenWidth >= 768 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
      const wrapper = swiperContainer.closest(".features_section");
      if (wrapper) wrapper.style.display = "flex";
    }
  }

  initOrDestroySwiper();
  window.addEventListener("resize", initOrDestroySwiper);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-section2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  let swiperInstance = null;

  function initOrDestroySwiper() {
    const screenWidth = window.innerWidth;
    const swiperContainer = document.querySelector(".unique-features-swiper");

    if (!swiperContainer) return;

    if (screenWidth < 768 && !swiperInstance) {
      const wrapper = swiperContainer.closest(".unique-features_section");
      if (wrapper) wrapper.style.display = "block";

      setTimeout(() => {
        swiperInstance = new Swiper(".unique-features-swiper", {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          loop:true,
          autoplay: {
            delay: 3000,
          },
          speed:500,
          breakpoints: {
            480: { slidesPerView: 1 },
            640: { slidesPerView: 1 },
          },
        });
      }, 100);
    } else if (screenWidth >= 768 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;

      const wrapper = swiperContainer.closest(".unique-features_section");
      if (wrapper) wrapper.style.display = "flex";
    }
  }

  initOrDestroySwiper();
  window.addEventListener("resize", initOrDestroySwiper);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider-video"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".heroSwiper", {
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "fraction",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
